import './tt.css';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function TAXIdb() { 
    const navigate = useNavigate();
    const tdb16 = process.env.PUBLIC_URL + '/tdb16.png';
    const tdb15 = process.env.PUBLIC_URL + '/tdb15.png';
    const tdb14 = process.env.PUBLIC_URL + '/tdb14.png';
    const tdb13 = process.env.PUBLIC_URL + '/tdb13.png';
    const tdb12 = process.env.PUBLIC_URL + '/tdb12.png';
    const tdb11 = process.env.PUBLIC_URL + '/tdb11.png';
    const tdb10 = process.env.PUBLIC_URL + '/tdb10.png';
    const tdb9 = process.env.PUBLIC_URL + '/tdb9.png';
    const tdb8 = process.env.PUBLIC_URL + '/tdb8.png';
    const tdb7 = process.env.PUBLIC_URL + '/tdb7.png';
    const tdb6 = process.env.PUBLIC_URL + '/tdb6.png';
    const tdb5 = process.env.PUBLIC_URL + '/tdb5.png';
    const tdb4 = process.env.PUBLIC_URL + '/tdb4.png';
    const tdb3 = process.env.PUBLIC_URL + '/tdb3.png';
    const tdb2 = process.env.PUBLIC_URL + '/tdb2.png';
    const tdb1 = process.env.PUBLIC_URL + '/tdb1.png';

    const [modalImage, setModalImage] = useState(null);

    const openModal = (image) => {
        setModalImage(image);
    };

    const closeModal = () => {
        setModalImage(null);
    };
    return(
        <div className="TAXIdb">
            <div className="middle-column">
                <h1>Taxi Database System Management</h1>
                <h4>Built with Flask, Python, and PostgreSQL</h4>
                <p>Taxi Database System Management is a web application that allows users to manage taxi-related data efficiently. It provides a user-friendly interface for performing CRUD (Create, Read, Update, Delete) operations on taxi records.</p>
                <img src={tdb14} alt="tdb14" onClick={() => openModal(tdb14)}/>
                <p>From the login screen you can choose to log in as a Manager, Client, or Driver.</p>                
                <img src={tdb12} alt="tdb12" onClick={() => openModal(tdb12)}/>
                <p>Or you can register as one of these modes as well. Each asks for its own information.</p>
                <img src={tdb13} alt="tdb13" onClick={() => openModal(tdb13)}/>
                <p>When you are logged in as a Manager, this will be your Dashboard view, and all the links of actions you can take in it.</p>
                <img src={tdb11} alt="tdb11" onClick={() => openModal(tdb11)}/>
                <p>On the Manage Cars & Models tab, the Manager can see the current cars and models, as well as add and/or delete them too.</p>
                <img src={tdb10} alt="tdb10" onClick={() => openModal(tdb10)}/>
                <p>On the Manage Drivers tab, you can create new Driver entries.</p>
                <img src={tdb9} alt="tdb9" onClick={() => openModal(tdb9)}/>
                <p>This is how you can see the "top" clients, meaning the ones who have booked more rents.</p>
                <img src={tdb8} alt="tdb8" onClick={() => openModal(tdb8)}/>
                <p>You can also see which cars were booked and for how many times.</p>
                <img src={tdb7} alt="tdb7" onClick={() => openModal(tdb7)}/>
                <p>Since the clients can leave reviews on the drivers that they booked a rent with, this is how the manager can see how well they performed. Here, the manager can choose to 'fire' the lowest rating ones.</p>
                <img src={tdb6} alt="tdb6" onClick={() => openModal(tdb6)}/>
                <p>This is a bit of a weird request, but you can technically see how many clients live in the same cities as the drivers.</p>
                <img src={tdb5} alt="tdb5" onClick={() => openModal(tdb5)}/>
                <p>This is the Client's Dashboard view. They can choose to add new addresses and/or credit card information.</p>
                <img src={tdb4} alt="tdb4" onClick={() => openModal(tdb4)}/>
                <p>This is where clients can pick a car brand and model (along with it the driver too) for their booking.</p>
                <img src={tdb3} alt="tdb3" onClick={() => openModal(tdb3)}/>
                <p>On the other hand, this is the driver's dashboard, and they can pick the cars/models they can drive from here. They can also change their addresses.</p>
                <img src={tdb2} alt="tdb2" onClick={() => openModal(tdb2)}/>
                <p>Finally, the last feature from the app side is where the Driver can see the reviews given to them from the clients they drove.</p>
                <img src={tdb1} alt="tdb1" onClick={() => openModal(tdb1)}/>
                <p>Now, for the PostgreSQL side of things, here are how the tables are arranged and how the schema looks like internally.</p>
                <img src={tdb15} alt="tdb15" onClick={() => openModal(tdb15)}/>
                <p>And here is an example of how the code looks from the inside.</p>
                <p>This specific screenshot shows how the app uses a try/catch method and interacts with the Database directly from the code in SQL queries.</p>
                <img src={tdb16} alt="tdb16" onClick={() => openModal(tdb16)}/>
                <p>This project was a fun way to bring together a database and a web app to handle how a taxi service might actually run. Each type of user gets their own space with tools that make sense for them, and everything ties together pretty smoothly.</p>
                <p>There’s still room to build on it, but it’s a solid start that does the job well.</p>
                <button onClick={() => navigate('/')}>Back to Homepage</button>               
            </div>
            {modalImage && (
                <div className="modal" onClick={closeModal}>
                    <span className="close" onClick={closeModal}>&times;</span>
                    <img className="modal-content" src={modalImage} alt="Modal" />
                </div>
            )}
        </div>
    )
}

export default TAXIdb;